// eslint-disable-next-line import/prefer-default-export
export const removeFocus = () => {
  if (document.activeElement instanceof HTMLElement) {
    document.activeElement.blur();
  }
};
